export const customerSuccessEmail = 'customer.success@swtchenergy.com'
